import React, { DragEvent, ChangeEvent, useState } from "react";

import { useDatabase } from "web/hooks";

import classes from './file_import.module.css';

export default function FileImport() {
  const [ dragging, setDragging ] = useState(false);
  const database = useDatabase();

  const importFile = async (file: File) => {
    console.log('import-file: size:', file.size)
    console.time('import-file');
    await database.importObservations(file);
    console.timeEnd('import-file');
    document.location.href = "/";
  };

  const onFileChange = async (evt: ChangeEvent) => {
    const target = evt.target as HTMLInputElement|null;
    const files = target?.files ?? [];
    if (files.length > 0) {
      await importFile(files[0]);
    } else {
      console.log("pick: no files");
    }
  };

  const onFileDrop = async (evt: DragEvent) => {
    evt.preventDefault();
    if (!evt.dataTransfer) { return }

    const item = [...evt.dataTransfer.items].find(item => item.kind === 'file');
    if (item != null) {
      await importFile(item.getAsFile()!);
    } else {
      console.log("drop: no files");
    }
  };

  const onDragOver = (evt: DragEvent) => {
    evt.preventDefault();
    setDragging(true);
  };
  const onDragEnd = (evt: DragEvent) => {
    evt.preventDefault();
    setDragging(false);
  }

  return <div className={ `${classes.root} ${dragging ? classes.dragging : ''}` }
    onDrop={ onFileDrop } onDragOver={ onDragOver }
    onDragEnd={ onDragEnd } onDragLeave={ onDragEnd }>
    <div className={ classes.drop_content }>

      <img src="/img/download.svg" />

      <div className={ classes.file_picker }>
        <input id={ classes.file_input } type="file" accept=".csv" onChange={ onFileChange } />
        <label htmlFor={ classes.file_input } className={ classes.file_input_label }>Pick your eBird file</label>
        <span className={ classes.or_drag }></span>
      </div>
      <p className={ classes.ebird_download }>
        { 'Download your eBird data at ' }
        <a href="https://ebird.org/downloadMyData" target="_blank">this page</a>
      </p>

    </div>
  </div>;

}
